export default class PresenceValidator {
  static isValid(value) {
    let isPresent = (
      (typeof(value) !== 'undefined') &&
      value !== null &&
      value !== ''
    );

    return isPresent;
  }
}
